import { InstallerPassStatusType } from '@bo-client/technician-management/tm-user/tm-user.model';

export class ValidPassWithUsersModel {
  idUser: number;
  userName: string;
  userMail: string;
  idPass: number;
  idarea: number;
  type: string;
  expirationdate: Date;
  isExpired = false;
  status: InstallerPassStatusType;
}

export class ValidAndExpiredPassModel {
  validPassList: ValidPassListModel[];
  expiredPassList: ExpiredPassModel[];
}

export class ValidPassListModel {
  id: number;
  name: string;
  description: string;
}

export class ExpiredPassModel {
  id?: number;
  description: string;
}
